import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import Search from "./svg/Search";
import Remove from "./svg/Remove";

const InputSearchQrType = ({
  onClearInput,
  className,
  searchBtnClassName,
  searchBtnText,
  ...props
}) => {
  return (
    <InputGroup
      className={`rounded-3 d-flex flex-nowrap${
        !!className ? ` ${className}` : ""
      }`}
    >
      <InputGroup.Text className="bg-white pe-0 me-0">
        <Search />
      </InputGroup.Text>
      <Form.Control
        type="text"
        className="border-start-0 border-end-0 search-input w-100"
        {...props}
      />
      {onClearInput && (
        <Button
          variant="link"
          className="bg-white border border-start-0 border-end-0 shadow-none"
          onClick={onClearInput}
        >
          <Remove />
        </Button>
      )}

      <Button
        variant="primary"
        className={`shadow-none py-2 ${
          !!searchBtnClassName ? `${searchBtnClassName}` : "w-100"
        }`}
        style={{ maxWidth: "115px" }}
      >
        {searchBtnText}
      </Button>
    </InputGroup>
  );
};

export default InputSearchQrType;
